module.exports = __webpack_public_path__ + "img/mixing-mastering.ca51ec8d.svg";